// extracted by mini-css-extract-plugin
export default {"anime":"AnimeSelected_anime__AGaD-","flex":"AnimeSelected_flex__yb4mp","faved":"AnimeSelected_faved__aKEpa"};